const readNotifications = (axios, params) => {
  return axios.post(`notifications/mark-as-read`, params);
};

export { readNotifications };
